module.exports = __webpack_public_path__ + "static/media/bg-gray-cpg.b8c678d3.webp";